import React from "react";
import { useState, useEffect } from "react";
import profile from "../images/profile.png";

const testimonialsData = [
  {
    id: 1,
    name: " Aditya Chettinadu Hotel",
    testimonial:
      "\"This platform is very helpful! It allows me to donate the excess food in our hotel to local charities who need it. The platform is very easy to use and reliable. It matches me with suitable recipients nearby, notifies me when they are ready to collect the food, and provides me with directions for the pick-up.\"",
    // image: aditya,
  },
  {
    id: 2,
    name: "Sedhurajan",
    testimonial:
      "\"I love this platform. It makes me feel good to help others by delivering food from food suppliers to the people who really need it.  I also get to meet and interact with other like-minded people who care about homeless and undernourished people\"",
    // image: onion,
  },
  {
    id: 3,
    name: "Amman Mess, Papampatti",
    testimonial:
      "\"This platform is amazing! It helps us save money and time by buying surplus food items from grocery stores at discounted prices. The food items are of good quality. I also like that I can donate some to support a good cause.\"",
    // image: onion,
  },
];

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="flex flex-col items-center justify-center text-center p-8 mx-auto shadow-md rounded-lg border border-gray-600">
      <img
        className="w-12 h-12 rounded mb-4"
        src={profile}
        alt={testimonial.name}
      />
      <h4 className="text-lg font-bold mb-2">{testimonial.name}</h4>
      <p className="text-gray-400">{testimonial.testimonial}</p>
    </div>
  );
};

const TestimonialSlider = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) =>
        prev === testimonialsData.length - 1 ? 0 : prev + 1
      );
    }, 3600);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center">
      <TestimonialCard testimonial={testimonialsData[currentTestimonial]} />
    </div>
  );
};

export default TestimonialSlider;
